export default __webpack_public_path__ + "static/media/cuetlogo.6349adeb.png";